// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questionnaires .tenant-disabled{color:var(--red);text-transform:uppercase}`, "",{"version":3,"sources":["webpack://./src/components/questionnaires/Questionnaires.vue"],"names":[],"mappings":"AAEE,iCACE,gBAAA,CACA,wBAAA","sourcesContent":["\n.questionnaires {\n  .tenant-disabled {\n    color: var(--red);\n    text-transform: uppercase;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
